import { useTranslate } from "@similarweb/i18n-provider";

import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import { useDigitalAssetsQuery } from "app/pages/sales-intelligence/modules/company-analysis/queries/useDigitalAssetsQuery";
import { digitalAssetTypeMap } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";

import Card from "../../../components/shared/Card/Card";
import CardHeader from "../../../components/shared/Card/CardHeader/CardHeader";

import { AppsCardContent } from "./AppsCardContent";
import { StyledSideBySideContainer } from "./styles";
import WebsitesCardContent from "./WebsitesCardContent";

const DigitalAssetsRoot = () => {
    const { translate } = useTranslate();
    const {
        params: { key: domain },
    } = useCurrentStateAndParamsWithFixedDomain();

    const { data: appsData, isFetched: isAppsFetched } = useDigitalAssetsQuery(domain, digitalAssetTypeMap.apps);
    const hasApps = isAppsFetched && !!appsData && appsData.length > 0;

    const { data: websitesData, isFetched: isWebsitesFetched } = useDigitalAssetsQuery(
        domain,
        digitalAssetTypeMap.websites,
        false,
    );
    const isWebsitesEmpty = isWebsitesFetched && (!websitesData || websitesData.length === 0);

    const websitesCard = (
        <Card
            dataAutomation="digital-assets-websites-card"
            isEmpty={isWebsitesEmpty}
            header={
                <CardHeader
                    title={translate("si.company-analysis.digital-assets.tabs.websites")}
                    infoTooltip={translate("si.company-analysis.digital-assets.card.header.tooltip")}
                />
            }
            renderContent={() => <WebsitesCardContent />}
        />
    );

    if (hasApps) {
        return (
            <StyledSideBySideContainer data-automation="digital-assets-side-by-side">
                {websitesCard}

                <Card
                    dataAutomation="digital-assets-apps-card"
                    header={
                        <CardHeader
                            title={translate("si.company-analysis.digital-assets.tabs.apps")}
                            infoTooltip={translate("si.company-analysis.digital-assets.apps.card.header.tooltip")}
                        />
                    }
                    renderContent={() => <AppsCardContent />}
                />
            </StyledSideBySideContainer>
        );
    }

    return websitesCard;
};

export default DigitalAssetsRoot;
